import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import {
  name as packageName,
  version as packageVersion,
} from '../../package.json';
assertPackageVersion(packageName, packageVersion);

export { addSuiExtension } from '../addSuiExtension';
export { NotSuiProviderError } from '../errors/NotSuiProviderError';
export { getSuiClient } from '../getSuiClient';
export { isSuiNetworkProvider } from '../isSuiNetworkProvider';
export { isSuiWalletAccount } from '../isSuiWalletAccount';
export { signAndExecuteTransaction } from '../signAndExecuteTransaction';
export { signAndExecuteTransactionBlock } from '../signAndExecuteTransactionBlock';
export { signTransaction } from '../signTransaction';
export { signTransactionBlock } from '../signTransactionBlock';
export type { SuiNetworkProvider } from '../SuiNetworkProvider.types';
export type { SuiWalletAccount } from '../SuiWalletAccount.types';
export type {
  SuiClient,
  SuiExecuteTransactionRequestType,
  SuiSignAndExecuteTransactionBlockResult,
  SuiSignAndExecuteTransactionResult,
  SuiSignTransactionBlockResult,
  SuiSignTransactionResult,
  SuiTransactionBlockResponseOptions,
} from '../SuiWalletProvider.types';
